// axios
import { AxiosError } from 'axios';

// internal
import { axios, def, storage, authencated, browseAsGuest, saveConfig, handleError } from './internal';

// index.html starts this request before the bundle downloads (window.__isauth, resolves to { status, data }).
// Hand it to axios as an adapter so interceptors, status validation and the .then/.catch below behave as for a real call.
// One-shot: retries (429) and later calls send a normal request.
function takePrefetched() {
    const pending = window.__isauth;
    window.__isauth = undefined;
    if (!pending) return undefined;
    return (config) =>
        pending.then(
            ({ status, data }) => {
                const response = { data, status, statusText: '', headers: {}, config, request: null };
                if (config.validateStatus(status)) return response;
                const kind = status >= 500 ? AxiosError.ERR_BAD_RESPONSE : AxiosError.ERR_BAD_REQUEST;
                throw new AxiosError(`Request failed with status code ${status}`, kind, config, null, response);
            },
            () => {
                throw new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, null);
            },
        );
}

function IsAuth(configHash, setData, attempt = 0) {
    setData?.((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/isauth', { configHash }, { guest: true, adapter: attempt === 0 ? takePrefetched() : undefined })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.AUTH_USERNAME_NOT_REGISTERED:
                    saveConfig(res.data.data?.config);
                    storage.transience.setState('path.gateway', 'signup');
                    break;
                case def.ErrorCode.AUTH_SERVICE_NOT_REGISTERED:
                    saveConfig(res.data.data?.config);
                    storage.transience.setState('path.gateway', 'login');
                    break;
                default:
                    authencated(res.data.data);
                    break;
            }
        })
        .catch((err) => {
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.UNAUTHORIZED:
                    // No session → browse as a guest; login is asked for on the first action.
                    browseAsGuest(data?.data?.config);
                    // Failed OAuth round-trip (?error=...) lands back on the login page.
                    if (new URLSearchParams(window.location.search).has('error')) {
                        storage.transience.setState('path.gateway', 'login');
                    }
                    break;
                case def.StatusCodes.FORBIDDEN:
                    switch (data?.code) {
                        case def.ErrorCode.AUTH_BANNED_USER:
                            storage.transience.setState({
                                'path.gateway': 'unauthorized',
                                'internal.blocked': new Date(data.data?.expire),
                            });
                            break;
                        case def.ErrorCode.AUTH_INACTIVE_USER:
                            storage.transience.setState({
                                'path.gateway': 'unauthorized',
                                'internal.inactive': true,
                            });
                            break;
                        case def.ErrorCode.AUTH_NOT_VERIFIED:
                            storage.transience.setState({
                                'path.gateway': 'signup-verify-email',
                                'signup.email': data.data?.email,
                            });
                            break;
                        default:
                        // 기타 403 처리
                    }
                    break;
                case def.StatusCodes.TOO_MANY_REQUESTS:
                    // Rate limited (Cloudflare window resets in seconds). Back off and retry
                    // a few times — otherwise the app hangs on the loading screen with no
                    // resolution. Bounded to avoid worsening the rate limit.
                    if (attempt < 3) {
                        setTimeout(() => IsAuth(configHash, setData, attempt + 1), 3000 * (attempt + 1));
                        return;
                    }
                    break;
                case def.StatusCodes.SERVICE_UNAVAILABLE:
                    if (data?.code === def.ErrorCode.AUTH_SERVER_MAINTENANCE) {
                        storage.transience.setState('path.gateway', 'maintenance');
                    } else {
                        storage.transience.setState('path.gateway', 'commingsoon');
                    }
                    break;
                case def.StatusCodes.NOT_FOUND:
                    // SIGNUP_USER_NOT_EXISTS 등
                    break;
                default:
                    handleError(err);
                    break;
            }
        })
        .finally(() => setData?.((prev) => ({ ...prev, loading: false })));
}

export { IsAuth };
